/* ============================================================
   Recently Viewed Products
   Stores last 10 product handles in localStorage.
   Renders via individual product page fetches (lightweight).
   ============================================================ */

(function() {
  'use strict';

  const STORAGE_KEY = 'ce:recently-viewed';
  const MAX_ITEMS = 10;

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function saveItem(handle) {
    if (!handle) return;
    let items = getItems();
    items = items.filter(h => h !== handle);
    items.unshift(handle);
    if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch(e) {}
  }

  /* Track current product */
  const productMeta = document.querySelector('[data-product-id]');
  if (productMeta) {
    const handle = window.location.pathname.split('/products/')[1];
    if (handle) {
      saveItem(handle.split('?')[0].split('#')[0]);
    }
  }

  /* Render recently viewed */
  const grid = document.getElementById('RecentlyViewedGrid');
  if (!grid) return;

  const items = getItems();
  const currentHandle = window.location.pathname.split('/products/')[1];
  const handles = items.filter(h => h !== currentHandle).slice(0, 6);

  if (handles.length === 0) {
    const section = document.getElementById('RecentlyViewed');
    if (section) section.style.display = 'none';
    return;
  }

  /* Fetch each product card via the search endpoint for efficiency */
  handles.forEach(handle => {
    fetch('/products/' + handle + '?view=card')
      .then(r => r.text())
      .then(html => {
        if (html && html.trim()) {
          const wrapper = document.createElement('div');
          wrapper.className = 'recently-viewed__item';
          wrapper.innerHTML = html;
          grid.appendChild(wrapper);
        }
      })
      .catch(() => {});
  });

})();
